export default  {"src":"/_next/static/image/public/assets/icons/see-all.c7e32c51da738053a4e149c0a91a410f.svg","height":14,"width":8};